<template>
  <div class="h-100">
    <div class="overflow-scroll p-1" ref="scrollable">
      <div class="d-flex align-items-center mb-1 flex-wrap flex-xl-nowrap">
        <div class="d-flex mb-1 mb-xl-0 w-100 align-items-center">
          <b-button variant="outline-secondary" class="size-button-center" @click="$emit('slide_window')">
             <span><feather-icon icon="MenuIcon"/></span>
          </b-button>
          
          <b-input-group class="ml-1 w-lg-auto">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon"></feather-icon>
            </b-input-group-prepend>
            <b-form-input :placeholder="$t('ia.community.findPrompt')" class="input-search-history" v-model="query"></b-form-input>
            <b-input-group-append is-text class="cursor-pointer" v-if="query && query.length > 0" @click="query = ''">
              <feather-icon icon="XIcon"></feather-icon>
            </b-input-group-append>
          </b-input-group>
        </div>
        <b-button 
          variant="blue-button" 
          class="blue-button create-your-own-button ml-xl-1 h-100"
          @click="redirectCreate()"
        >
          {{ $t('ia.community.creteOwn') }}
        </b-button>
      </div>

      <div class="border-bottom py-2" v-if="!query && popular_themes.length > 0">
        <h2>{{ $t('ia.community.popularThemes') }}</h2>
        <div class="grid-covers">
          <div 
            class="cover-term" 
            v-for="(image, index) in popular_themes.slice(0, 2)" 
            :key="index"
            @click="query = image.title"
          >
            <b-img :src="image.static_image" class="image-cover-term"></b-img>
          </div>
        </div>
      </div>

      <div class="py-2 overflow-results" :class="{'border-bottom': images_community.length > 0}">
        <h3>{{ $t('ia.community.iaCommunity') }}</h3>
        <p class="avenir-medium" v-if="query">{{ $t('ia.community.searchKey')}}: {{ query }}</p>

        <vue-masonry-wall 
          :items="images_community" 
          :options="{width: 320, padding: 8}" 
          @append="getCommunityImages"
          ref="grid_item"
          v-if="(images_community.length > 0 && loaded_service)"
        >
          <template v-slot:default="{item}">
            <div v-if="item && item.images && item.images.length > 0" :class="{'border-light-grid': rendered}" class="container-image-grid-community" @click="clickCardOpenModal(item)">
              <b-img :src="item.images[0] || ''" class="img-community" @error="errorLoad(item)" @load="renderedImage"></b-img>
              <div class="hover-container-info">
                <div>
                  <div class="d-flex justify-content-between container-top-hover align-items-center">
                    <div>
                      <b-avatar class="mr-05" :src="verifyAsset(item.user && item.user.avatar ? item.user.avatar : '')"></b-avatar> <span>{{ item.user ? item.user.first_name : '' }}</span>
                    </div>
                    <div @click.stop="downloadFile(item.images[0])">                      
                      <feather-icon icon="DownloadIcon" size="20"></feather-icon>
                    </div>
                  </div>
                </div>
                <span class="container-bottom-hover">{{ item.processed_prompt ? item.processed_prompt.substring(0, 100) : '' }}
                {{ item.processed_prompt && item.processed_prompt.length > 100  ? '...' : ''}}
                </span>
              </div>
            </div>
          </template>
        </vue-masonry-wall>

        <!-- Empty state when no results found -->
        <div v-else-if="loaded_service && images_community.length === 0" class="empty-state-community text-center">
          <b-img :src="require('@/assets/images/svg/not-found.svg')" class="empty-state-image mb-2"></b-img>
          <h3>{{ $t('ia.history.noResults') }}</h3>
          <p class="avenir-medium text-muted" v-if="query">
            {{ $t('ia.history.noResultsMatchin') }} "<strong>{{ query }}</strong>"
          </p>
          <p class="avenir-medium text-muted" v-else>
            {{ $t('ia.community.noImagesYet') }}
          </p>
          <b-button v-if="query" variant="blue-button" class="blue-button" @click="query = ''">
            {{ $t('ia.history.clearSearch') }}
          </b-button>
        </div>

        <!-- Loading skeletons -->
        <vue-masonry-wall 
          v-else
          :items="skeletonItems" 
          :options="{width: 320, padding: 8}"
        >
          <template v-slot:default="{item}">
            <div class="skeleton-card" :style="{height: item.height}">
              <b-skeleton-img animation="wave" class="skeleton-image h-100"></b-skeleton-img>
            </div>
          </template>
        </vue-masonry-wall>
      </div>
    </div>

    <b-modal v-model="show_modal" hide-footer hide-header centered id="modal-backdrop-swiper" size="lg">
      <div class="container-modal-extra-info row" v-if="Object.keys(image_selected).length > 0 && image_selected.images && image_selected.images.length > 0">
        <b-img :src="image_selected.images[0]" class="image-selected col-12 col-lg-6 p-0"></b-img>
        <div class="col-12 col-lg-6 p-2">
          <div class="border-bottom pb-2">
            <div class="mb-2">
              <b-avatar class="avatar" :src="verifyAsset(image_selected.user && image_selected.user.avatar ? image_selected.user.avatar : '')"></b-avatar> <span>{{ image_selected.user ? image_selected.user.first_name : '' }}</span>
            </div>
            <h2 class="mb-2">{{ image_selected.original_prompt || '' }}</h2>
            <div>
              <p class="text-muted avenir-medium text-uppercase">PROMPT</p>
              <p>{{ image_selected.processed_prompt || '' }}</p>
            </div>
            <b-button variant="outline-secondary" @click.once="downloadFile(image_selected.images[0])">{{ $t('mediaKits.download')}}</b-button>
          </div>
          <div class="pt-2 row">
            <div class="col-6 mb-1">
              <span class="d-block avenir-medium text-uppercase">{{ $t('ia.community.model')}}</span>
              <span class="d-block">{{ getModelLabel(image_selected) }}</span>
            </div>


            <div class="row m-0 w-100">
              <div class="col-6">
                <span class="d-block avenir-medium text-uppercase">{{  image_selected.data && image_selected.data.model !== 'imagine' ? 'SIZE' : 'ASCPECT RATIO' }}</span>
                <span class="d-block">{{ getSizeOrAspectRatio(image_selected) }}</span>
              </div>
              <div class="col-6">
                <span class="d-block avenir-medium text-uppercase">{{ $t('search.negativePromp') }}</span>
                <span class="d-block"> {{ image_selected.data && image_selected.data.negative_prompt ? image_selected.data.negative_prompt : '--' }}</span>
              </div>
            </div>
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          size="24"
          class="close-icon-modal"
          @click="show_modal = !show_modal"
        />
      </div>
    </b-modal>
  </div>
</template>
    
<script>

import {
  BImg,
  BButton,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BAvatar,
  BModal,
  BSkeletonImg,
} from 'bootstrap-vue';
import config from '@/services/config';
import { getCommunityImages, getPopularThemes } from '@/services/ia'
import { verifyAsset } from '@/libs/utils/urls';
import { downloadFile } from '@/libs/utils/others';
import VueMasonryWall from 'vue-masonry-wall';

export default {
  name: 'communityGrid',
  components: {
    BImg,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BAvatar,
    BModal,
    BSkeletonImg,
    VueMasonryWall
  },
  data() {
    return {
      verifyAsset,
      downloadFile,
      axios: null,
      cancel_search_ws: null,
      query: undefined,
      loaded_service: false,
      images_community: [],
      update_image: false,
      popular_themes: [],
      show_modal: false,
      image_selected: {},
      rendered: false,
      failed_images: [],
      has_more_images: true,
      is_loading_more: false,
      skeletonItems: [
        { height: '250px' }, { height: '320px' }, { height: '280px' }, 
        { height: '300px' }, { height: '350px' }, { height: '270px' },
        { height: '310px' }, { height: '290px' }, { height: '330px' },
        { height: '260px' }, { height: '340px' }, { height: '285px' }
      ],
    }
  },
  props: {
    category_selected: {
      type: Object,
      default: () => {
        return {}
      },
    }
  },
  async mounted() {
    this.axios = (await import('axios')).default;
    this.$refs.scrollable.addEventListener('scroll', this.checkVisibility);
    this.checkVisibility();
  },
  created() {
    this.getCommunityImages();
    this.getPopularThemes();
  },
  methods: {
    getModelLabel(image) {
      if (!image || !image.data || !image.data.model) return '--';
      const list = this.$t('search.ia_options') || [];
      if (!Array.isArray(list)) return '--';
      const found = list.find(i => i.value === image.data.model);
      return found?.label || '--';
    },
    getSizeOrAspectRatio(image) {
      if (!image || !image.data) return '--';
      if (image.data.model !== 'imagine') {
        return image.size_images || '--';
      }
      return image.data.aspect_ratio || '--';
    },
    checkVisibility() {
      const scroll_area = this.$refs.scrollable;
      const grid_items = this.$refs.grid_item ? this.$refs.grid_item.$el.children : [];
      let items_grid = [];
      grid_items.forEach(i => {
        items_grid = [...items_grid, ...i.children]
      });
      if (!scroll_area || items_grid.length === 0) return;
      const scroll_area_rect = scroll_area.getBoundingClientRect();
      
      if (items_grid.length > 0) {
        items_grid.forEach(item => {
          const rect = item.getBoundingClientRect();
          const is_sort_of_visible = (rect.bottom >= scroll_area_rect.top && rect.top <= scroll_area_rect.bottom);
          if (is_sort_of_visible) {
            item.classList.add('get-animation-blur-scale')
          } else {
            item.classList.remove('get-animation-blur-scale')
          }
        });
      }
    },
    renderedImage() {
      this.rendered = true;
      this.checkVisibility();
    },
    clickCardOpenModal(image) {
      this.image_selected = image;
      this.show_modal = true; 
    },
    getPopularThemes() {
      getPopularThemes().then((response) => {
        this.popular_themes = response.results;
        this.popular_themes.map((i) => {
          i['static_image'] = i.images[Math.floor(Math.random() * i.images.length)]
        })
      })
    },
    getCommunityImages() {
      if (!this.has_more_images || this.is_loading_more) return;
      
      this.is_loading_more = true;
      
      const data = {
        number: 12,
        prev_images: [
          ...this.images_community.map(i => i.uuid),
          ...this.failed_images
        ],
        query: this.query && this.query.length > 0 ? this.query : undefined
      }
      getCommunityImages(data).then((response) => {
        this.setFormatData(response)
      }).finally(() => {
        this.is_loading_more = false;
      });
    },
    setFormatData(response) {
      const validResults = (response.results || []).filter(item => item && item.images && item.images.length > 0);
      
      if (validResults.length === 0 || validResults.length < 12) {
        this.has_more_images = false;
      }
      
      this.images_community = this.images_community.concat(validResults);
      setTimeout(() => {
        this.loaded_service = true;
      }, 20)
    },
    redirectCreate() {
      this.$router.push({ name: 'brandme_AI', params: {section:'image', category: 'txt-to-image'}}).catch(() => {})
      this.category_selected.section = 'image';
      this.category_selected.category = 'txt-to-image';
    },
    errorLoad(item) {
      this.failed_images.push(item.uuid);
      this.images_community = this.images_community.filter(el => el !== item);
      this.update_image = !this.update_image;
    },
    searchQuery(query) {
      const CancelToken = this.axios.CancelToken;
      if (this.cancel_search_ws) this.cancel_search_ws()
      const self = this;
      
      this.has_more_images = true;
      this.is_loading_more = false;
      
      const data = {
        query,
        number: 12
      }
      this.axios({
        method: 'post',
        url: `${config.urlCore}/api/v3/ai/community-images/`,
        data,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        cancelToken: new CancelToken(function executor(c) {
          self.cancel_search_ws = c;
        })
      }).then((response) => {
        const validResults = (response.data.response.results || []).filter(item => item && item.images && item.images.length > 0);
        
        if (validResults.length === 0 || validResults.length < 12) {
          this.has_more_images = false;
        }
        
        this.images_community = validResults;
      })
    },
  },
  watch: {
    query(val) {
      if (val.length === 0) {
        this.images_community = [];
        this.has_more_images = true;
        this.is_loading_more = false;
        this.getCommunityImages();
      } else this.searchQuery(val)
    },
  }
}
</script>
<style lang="scss" scoped>
.border-light-grid {
  border: 1px solid #cccccc71;
}
.container-image-grid-community {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 0.7em;

  .hover-container-info {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.644);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 1em;
    color: white;
    opacity: 0;
    transition: all 300ms;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .container-top-hover {
      transform: translateY(-50px);
      transition: all 300ms;
    }
    .container-bottom-hover {
      transform: translateY(100px);
      transition: all 300ms;

    }
  }

  &:hover {
    .hover-container-info {
      opacity: 1;
    }
    .container-top-hover {
      transform: translateY(0px);
    }
    .container-bottom-hover {
      transform: translateY(0px);
    }
  }
}
.overflow-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  .mr-05 {
    margin-right: 0.5em;
  }
  .create-your-own-button {
    flex-shrink: 0;
    width: 100%;
    
    @media(min-width: 1200px) {
      width: auto;
    }
  }
  .grid-covers {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2em;
    grid-auto-flow: dense;
    .cover-term {
    
      aspect-ratio:  100% / 200;
      border-radius: 1em;
      font-size: 3em;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100px;
      max-height: 200px;
      cursor: pointer;
      overflow: hidden;

      .image-cover-term {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }

      @media(max-width: 430px) {
        width: 100%;
        aspect-ratio: 0 / 0;
      }
    }
    @media(max-width: 800px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  .size-button-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 3rem;
  }
  .input-search-history {
    height: 3rem;
  }
  .skeleton-card {
    border-radius: 0.7em;
    overflow: hidden;
    background-color: #f5f5f5;
    
    .skeleton-image {
      width: 100%;
      height: 100% !important;
      border-radius: 0.7em;
    }
    
    .b-aspect {
      height: 100% !important;
    }
  }
  
  .container-loader-grid-results {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 500px;
    .spinner {
      height: 6em;
      width: 6em;
      color: #acacac;
    }
  }
  .empty-state-community {
    width: 100%;
    padding: 3em 2em;
    min-height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    .empty-state-image {
      width: 120px;
      height: 120px;
      opacity: 0.7;
    }
    
    h3 {
      margin-bottom: 0.5em;
    }
    
    p {
      max-width: 500px;
      margin-bottom: 1.5em;
    }
  }
}
.container-modal-extra-info {
  background-color: white;
  padding: 1.2em;
  border-radius: 1em;
  .image-selected {
    width: 100%;
    object-fit: contain;
    border-radius: 0.8em;
    background-color: #cccccc71;
  }
  .avatar {
    width: 40px;
    height: 40px;
    margin-right: 0.7em;
  }
  .close-icon-modal {
    position: absolute;
    top: 2em;
    right: 2em;
    color: #979797;
    cursor: pointer;

    @media(max-width: 991px) { 
      background-color: white;
      top: 3em;
      right: 2.7em;
      border-radius: 100%;
    }
  }
}
</style>
<style lang="scss">
#modal-backdrop-swiper {
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  opacity: 9;
  .modal-content {
    border-radius: 2em;
    background-color: transparent;
    box-shadow: none;
  }
}
.img-community {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.get-animation-blur-scale {
  transition: all 1s;
  animation: animation-blur 500ms !important;
  @keyframes animation-blur {
    0% {
      transform: scale(1.15);
      filter: blur(20px);
    }
    100%{
      transform: scale(1);
      filter: none;
    }
  }
}

</style>
